/* nm-track.js - Netmantos first-party click + attribution tracker.
 *
 * Captures HOW a visitor reaches a product (which carousel, search, position)
 * and stamps that path into the cart so the order carries real attribution.
 * Event names + params are ENGLISH on purpose: they travel to the browser and
 * the customer can read them. The admin panel translates them to Portuguese.
 *
 * Events sent to the collector:
 *   view_item_list  list became visible (impression)
 *   select_item     clicked a product card (the surface they came from)
 *   view_item       product page view
 *   search          searched (query + results count)
 *   add_to_cart     added to cart
 *   begin_checkout  went to checkout
 *
 * On add_to_cart it writes cart attributes nm_sid / nm_path / nm_list; the order
 * webhook reads them server-side -> purchase attribution with real revenue.
 *
 * Markup contract (set in theme):
 *   [data-nm-list="<name>"]  wraps a product list/carousel
 *   [data-nm-card]           a product card; carries data-nm-pid + data-nm-handle
 */
(function () {
  "use strict";

  var NM = {
    endpoint: "https://t.netmantosfc.com/c",
    sessMs: 30 * 60 * 1000, // sliding 30-min session
  };

  // ── ids + session (cookieless, no PII) ─────────────────────────────────────
  function rid() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }
  function getVid() {
    try {
      var v = localStorage.getItem("nm_vid");
      if (!v) { v = rid(); localStorage.setItem("nm_vid", v); }
      return v;
    } catch (e) { return null; }
  }
  // One session blob holds id + breadcrumb + last list, replaced on expiry
  // (no per-session key leak in localStorage).
  function loadSess() {
    var now = Date.now();
    try {
      var o = JSON.parse(localStorage.getItem("nm_sess") || "null");
      if (o && o.id && now - o.t < NM.sessMs) return o;
    } catch (e) {}
    return { id: rid(), t: now, path: [], list: "" };
  }
  var S = loadSess();
  var vid = getVid();
  function saveSess() {
    S.t = Date.now();
    try { localStorage.setItem("nm_sess", JSON.stringify(S)); } catch (e) {}
  }
  saveSess();

  function pushPath(tag) {
    if (!tag || S.path[S.path.length - 1] === tag) return;
    S.path.push(tag);
    if (S.path.length > 12) S.path = S.path.slice(-12);
    saveSess();
  }
  function pathStr() { return S.path.join(">").slice(0, 240); }
  function setLastList(list) { S.list = list || ""; saveSess(); }

  // ── transport ──────────────────────────────────────────────────────────────
  function send(ev) {
    try {
      ev.sid = S.id;
      if (vid) ev.vid = vid;
      ev.url = location.pathname + location.search;
      var payload = JSON.stringify(ev);
      var blob = new Blob([payload], { type: "text/plain" });
      if (navigator.sendBeacon && navigator.sendBeacon(NM.endpoint, blob)) return;
      fetch(NM.endpoint, {
        method: "POST", body: payload, keepalive: true,
        headers: { "Content-Type": "text/plain" },
      }).catch(function () {});
    } catch (e) {}
  }


  // ── identify (e-mail do popup de boas-vindas) ───────────────────────────────
  // Liga a sessao ao e-mail. Sem isso, quem monta carrinho e sai ANTES do
  // checkout e invisivel: a Shopify so cria o carrinho abandonado depois que o
  // contato e preenchido no checkout, e isso era 82% do abandono real.
  // Nao intercepta nem atrasa o submit - so escuta e manda em paralelo.
  var idJa = {};
  function identify(email) {
    email = String(email || "").trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s.]+\.[^@\s]+$/.test(email)) return;
    if (idJa[email]) return;            // um por e-mail por sessao
    idJa[email] = 1;
    send({ e: "identify", email: email });
  }
  NM.identify = identify;
  try { window.nmIdentify = identify; } catch (e) {}

  // Outros scripts do tema mandam evento pelo MESMO transporte e pela MESMA sessao
  // (hoje o popup "Editar" do carrinho). So escrita, sem nada digitado pelo cliente.
  try {
    window.nmTrack = function (ev) {
      if (ev && typeof ev === "object" && ev.e) send(ev);
    };
  } catch (e) {}

  // ── quem chegou por link de e-mail ─────────────────────────────────────────
  // O redirect /r/ carimba nm_e={trackId} no destino. Mandar o id (nunca o
  // e-mail, que nao pode viajar em URL) faz o servidor resolver de quem e a
  // sessao, e dali em diante a jornada inteira fica ligada aquela pessoa:
  // home, busca, outro produto, carrinho, checkout.
  // O nm_e so existe na PRIMEIRA url depois do clique. Guardar no localStorage e
  // reenviar a cada sessao nova e o que mantem a jornada inteira ligada a pessoa:
  // sem isso, quem clica no e-mail, sai e volta uma hora depois vira anonimo de
  // novo, e a coleção que ela abriu nessa volta fica orfa.
  var KEY_TRK = "nm_e_track";
  function identifyPorTrack() {
    try {
      var url = new URLSearchParams(location.search).get("nm_e");
      if (url) {
        try { localStorage.setItem(KEY_TRK, String(url).slice(0, 40)); } catch (e) {}
      }
      var trk = "";
      try { trk = localStorage.getItem(KEY_TRK) || ""; } catch (e) {}
      if (!trk) return;
      // uma vez por SESSAO, mas o track sobrevive a sessao inteira no aparelho
      if (sessionStorage.getItem("nm_e_sent")) return;
      sessionStorage.setItem("nm_e_sent", "1");
      send({ e: "identify", track: trk });
    } catch (e) {}
  }
  identifyPorTrack();

  // Pega o e-mail de QUALQUER formulario de captura da loja (popup de
  // boas-vindas, rodape, o que vier depois) sem precisar editar cada um.
  function wireEmailForms() {
    document.addEventListener("submit", function (ev) {
      try {
        var f = ev.target;
        if (!f || f.tagName !== "FORM") return;
        var i = f.querySelector('input[type="email"], input[name="contact[email]"]');
        if (i && i.value) identify(i.value);
      } catch (e) {}
    }, true);   // capture: roda antes do handler do tema, que costuma dar preventDefault
  }

  // ── view_item_list (impressions) ────────────────────────────────────────────
  var io, observed, seen = {};
  function ensureIO() {
    if (io) return;
    observed = new WeakSet();
    io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var list = el.getAttribute("data-nm-list") || "";
        if (!seen[list]) { seen[list] = 1; send({ e: "view_item_list", list: list }); }
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
  }
  function scanLists(root) {
    ensureIO();
    var els = (root || document).querySelectorAll("[data-nm-list]");
    for (var i = 0; i < els.length; i++) {
      if (!observed.has(els[i])) { observed.add(els[i]); io.observe(els[i]); }
    }
  }

  // ── select_item (card click = the surface they came from) ───────────────────
  document.addEventListener("click", function (ev) {
    var card = ev.target.closest && ev.target.closest("[data-nm-card]");
    if (!card) return;
    var listEl = card.closest("[data-nm-list]");
    // explicit data-nm-list wins; otherwise derive the surface from the page
    var list = (listEl && listEl.getAttribute("data-nm-list")) || deriveList();
    var pos = listEl
      ? Array.prototype.indexOf.call(listEl.querySelectorAll("[data-nm-card]"), card) + 1
      : null;
    setLastList(list);
    pushPath("list:" + list);
    send({
      e: "select_item", list: list, position: pos || null,
      product_id: card.getAttribute("data-nm-pid") || null,
      handle: card.getAttribute("data-nm-handle") || null,
    });
  }, true); // capture: fire before the link navigates (sendBeacon survives nav)

  // ── view_item (PDP) ─────────────────────────────────────────────────────────
  function emitViewItem() {
    if (!/\/products\//.test(location.pathname)) return;
    var pid = null, handle = null;
    try {
      pid = window.ShopifyAnalytics && ShopifyAnalytics.meta &&
            ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id;
    } catch (e) {}
    var m = location.pathname.match(/\/products\/([^\/\?]+)/);
    if (m) handle = m[1];
    pushPath("pdp");
    send({ e: "view_item", product_id: pid ? String(pid) : null, handle: handle, ref: document.referrer || "" });
  }

  // ── search ──────────────────────────────────────────────────────────────────
  function wireSearch() {
    var inputs = document.querySelectorAll('input[name="q"], #search-template');
    var lastQ = "", tmr = null, count = null;
    function fire(q) {
      if (!q || q.length < 2 || q === lastQ) return;
      lastQ = q; pushPath("search");
      send({ e: "search", query: q, results: count });
    }
    for (var i = 0; i < inputs.length; i++) {
      (function (inp) {
        inp.addEventListener("input", function () {
          clearTimeout(tmr);
          var q = inp.value.trim();
          tmr = setTimeout(function () { fire(q); }, 700);
        });
      })(inputs[i]);
    }
    // predictive results count (best-effort)
    var box = document.querySelector("[data-predictive-search]");
    if (box && window.MutationObserver) {
      new MutationObserver(function () {
        count = box.querySelectorAll('[data-nm-card], .product-item, a[href*="/products/"]').length;
      }).observe(box, { childList: true, subtree: true });
    }
    // search results page: reliable count
    if (/\/search/.test(location.pathname)) {
      try {
        var q = new URLSearchParams(location.search).get("q");
        if (q) {
          var grid = document.querySelectorAll('[data-nm-card], .product-item');
          pushPath("search");
          send({ e: "search", query: q, results: grid.length });
        }
      } catch (e) {}
    }
  }

  // ── add_to_cart + cart attribute stamping ───────────────────────────────────
  var lastCount = null, stamping = false;
  function stampCart() {
    if (stamping) return;
    stamping = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: { nm_sid: S.id, nm_path: pathStr(), nm_list: S.list } }),
    }).catch(function () {}).then(function () { stamping = false; });
  }
  function checkCart(forcado) {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = cart.item_count;
        if (Date.now() < pulaAte) { lastCount = c; return; }           // edicao em curso: so re-sincroniza
        if (lastCount === null && !forcado) { lastCount = c; return; } // prime, no event
        // forcado = a chamada foi um /cart/add: e adicao mesmo mesmo sem contagem anterior
        if (forcado || c > lastCount) {
          lastCount = c;
          var item = cart.items && cart.items[0]; // Shopify puts the newest at index 0
          // pacote de brinde entra sozinho no checkout (preco 0): nao e o cliente adicionando camisa
          if (item && item.price === 0) return;
          send({
            e: "add_to_cart",
            product_id: item ? String(item.product_id) : null,
            handle: item ? item.handle : null,
            value: cart.total_price ? cart.total_price / 100 : null,
            list: S.list,
          });
          pushPath("add_to_cart");
          stampCart(); // attribute update fires cart events again but item_count is unchanged -> no double count
        } else {
          lastCount = c;
        }
      })
      .catch(function () {});
  }
  ["cart:updated", "cart:refresh", "cart:change"].forEach(function (evt) {
    document.addEventListener(evt, function () { checkCart(); });
  });
  // Este tema nao dispara nenhum evento cart:*, entao os listeners acima nunca veem nada: olhamos a
  // propria chamada de carrinho, como a barra de cupom ja faz aqui. O add do popup de editar vem com
  // X-NM-Skip (troca de linha que ja estava no carrinho), e nao conta camisa nova.
  var CART_RX = /\/cart\/(add|change|update|clear)/;
  function ehPulo(init, input) {
    try {
      var h = (init && init.headers) || (input && input.headers);
      if (!h) return false;
      if (typeof h.get === "function") return !!h.get("X-NM-Skip");
      return !!(h["X-NM-Skip"] || h["x-nm-skip"]);
    } catch (e) { return false; }
  }
  var pulaAte = 0;   // enquanto o popup de editar troca a linha, nada no carrinho e camisa nova
  function olhaDepois(url, pulo) {
    if (stamping) return;                     // a nossa propria gravacao de atributo nao conta
    if (pulo) pulaAte = Date.now() + 4000;    // cobre o add novo E a saida da linha antiga
    var add = /\/cart\/add/.test(url) && !pulo;
    setTimeout(function () { checkCart(add); }, 250);
  }
  try {
    var fetchAntes = window.fetch;
    if (typeof fetchAntes === "function") {
      window.fetch = function (input, init) {
        var url = (typeof input === "string") ? input : (input && input.url) || "";
        var p = fetchAntes.apply(this, arguments);
        /* nada aqui pode derrubar o fetch de quem chamou: a instrumentacao inteira e opcional */
        try {
          if (CART_RX.test(String(url)) && p && typeof p.then === "function") {
            var pulo = ehPulo(init, input);
            p.then(function () { olhaDepois(String(url), pulo); }, function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    var abrirAntes = XMLHttpRequest.prototype.open, mandarAntes = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__nmUrl = String(u || ""); return abrirAntes.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      if (CART_RX.test(self.__nmUrl || "")) {
        self.addEventListener("load", function () { olhaDepois(self.__nmUrl, false); });
      }
      return mandarAntes.apply(this, arguments);
    };
  } catch (e) {}

  // ── begin_checkout ──────────────────────────────────────────────────────────
  // So o clique nao basta: o botao de finalizar do carrinho lateral e um submit e o clique nao chega
  // ate aqui (medido no ar, 11/09). Entao ouvimos clique E submit, com trava pra nao contar duas vezes.
  var checkoutEm = 0;
  function marcarCheckout() {
    var agora = Date.now();
    if (agora - checkoutEm < 5000) return;
    checkoutEm = agora;
    pushPath("checkout");
    stampCart();
    send({ e: "begin_checkout" });
  }
  document.addEventListener("click", function (ev) {
    var t = ev.target.closest && ev.target.closest('[name="checkout"], button[name="checkout"], a[href*="/checkout"]');
    if (t) marcarCheckout();
  }, true);
  document.addEventListener("submit", function (ev) {
    try {
      var f = ev.target;
      if (!f) return;
      var b = ev.submitter;                      // qual botao enviou: separa "atualizar" de "finalizar"
      if (b && (b.name === "checkout" || b.id === "checkout")) return marcarCheckout();
      var acao = String((f.getAttribute && f.getAttribute("action")) || f.action || "");
      if (/\/checkout/.test(acao)) marcarCheckout();
    } catch (e) {}
  }, true);

  // ── init ────────────────────────────────────────────────────────────────────
  // Name the surface from page context when a card has no [data-nm-list] ancestor
  // (collection grid, search results, PDP related). Keeps theme edits surgical.
  function deriveList() {
    var p = location.pathname;
    var m = p.match(/\/collections\/([^\/\?]+)/);
    if (m) return "collection:" + m[1];
    if (/\/search/.test(p)) return "search-results";
    if (/\/products\//.test(p)) return "pdp-related";
    if (p === "/" || /^\/(\?|$)/.test(p)) return "home";
    return "unknown";
  }
  function pageTag() {
    var p = location.pathname;
    if (p === "/" || /^\/(\?|$)/.test(p)) return "home";
    if (/\/products\//.test(p)) return "pdp";
    if (/\/collections\//.test(p)) return "collection";
    if (/\/search/.test(p)) return "search";
    if (/\/cart/.test(p)) return "cart";
    return "page";
  }
  function init() {
    pushPath(pageTag());
    emitViewItem();
    scanLists();
    wireSearch();
    wireEmailForms();
    checkCart(); // prime cart count (no event on first read)
    // re-scan for carousels injected later (cart drawer upsell, ajax sections)
    if (window.MutationObserver) {
      var deb;
      new MutationObserver(function () {
        clearTimeout(deb);
        deb = setTimeout(function () { scanLists(); }, 400);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
